import CrossIcon from '@/common/assets/icons/cross.svg?react';
import Button from '@/common/components/base/button/Button.tsx';
import useModal from '@/common/hooks/useModal';
import useToast from '@/common/store/alert/useToast';
import DeactivateActionModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/deactivitateActionModal/DeactivateActionModal';
import { ParticipantIncidentDeactivateType } from '@/modules/adjusterReportModules/IncidentParticipants/components/ParticipantActions/components/participantIncidentDeactivate/ParticipantIncidentDeactivate.type';
import { deactivateMutationOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deactivate/deactivateQueryOptions';
import { participantsIncidentQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/participantsIncidentList/participantsIncidentQueryOptions';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default ({ id, name }: ParticipantIncidentDeactivateType) => {
  const { mutateAsync: activateParticipant, isPending } = useMutation(
    deactivateMutationOptions(),
  );
  const { closeModal, open, openModal } = useModal();
  const param = useParams();
  const queryClient = useQueryClient();
  const showAlert = useToast((state) => state.showAlert);
  const { isRefetching: loading } = useQuery(
    participantsIncidentQueryOptions({ id: param.id! }),
  );

  return (
    <>
      <Flex
        onClick={() => openModal()}
        key={id}
        height={'26px'}
        textWrap={'nowrap'}
        width={'350px'}
        alignItems={'center'}
      >
        <Button
          gap="5px"
          fullWidth
          fontSize={'11px'}
          variant="text"
          color="common"
          display={'flex'}
          w={'100%'}
        >
          <CrossIcon
            className={css({
              position: 'relative',
            })}
            fill={token('colors.gray-2')}
          />
          غیرفعال سازی
        </Button>
      </Flex>
      <DeactivateActionModal
        id={id}
        loading={loading || isPending}
        open={open}
        deactivateAction={() => {
          showAlert({
            type: 'success',
            description: 'زیاندیده غیرفعال شد!',
          });
          return activateParticipant({
            id: param.id!,
            formData: { damaged_pk: id },
          }).then(() =>
            queryClient.invalidateQueries({
              queryKey: participantsIncidentQueryOptions({
                id: param.id!,
                enable: true,
              }).queryKey,
            }),
          );
        }}
        closeModal={closeModal}
        name={name}
      />
    </>
  );
};
